import React from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircleFilled } from "@ant-design/icons";
import CommonButton from "Components/CommonButton";
import "./PaidAssessment.scss";
import { CONSTANTS } from "utils/constant";
import { CheckedGreenIcon } from "Common/ReactIcons";
import utils from "utils";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { TS_STYLD_COMPS } from "Common/constant";
import { Trans } from "react-i18next";
const PaymentSuccess = (props) => {
  const { score_details,
    plan_details,
    assessment_details, paymentData,txnDate ,tgtLangST,t,couponCode,applyCoupon,tgtLang } = props;
    const history=useHistory();
  const display_data = {
    report_created_date:`${utils.FormatDate(txnDate, "DATE_TIME_3")}`,
    order_no: paymentData?.billDeskData?.order_data
      ?.order_number || assessment_details.order_no,
    total_price: Number(assessment_details.report_price).toFixed(2),
    discount_price: Number(assessment_details.discounted_price).toFixed(2),
    paid_price: Number(assessment_details.final_price).toFixed(2),
    currency: ` ${utils.currencyCodeToSymbol(assessment_details.currency)}`,
    plan_name:assessment_details.plan_name,
  }
  function btnActionHandler() {
    const baseUrl="/logged-in-user"
    props.setHeadingQuestionType(score_details.assessment_type)
    history?.push({
      pathname: `${baseUrl}/score-details`,
      state: {
        from: "assessment-history",
        score_details: score_details,
      },
    });
  }
  return (
    <div className="payment-success-container">
      <div className="success-box">
        <div>
          <CheckedGreenIcon />
        </div>
        <div className="success-title"><Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.PAYMENT_SUCCESSFUL,{lng:tgtLangST})}</Trans></div>
        <div className="created-date">
          <Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.REPORT_CREATED_ON,{lng:tgtLangST})}</Trans>{` ${display_data.report_created_date}`}
        </div>

        <div className="report-box">
          {/* <div className="report-title"><Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.DETAILED_SELF_ASSESSMENT_REPORT,{lng:tgtLangST})}</Trans></div> */}
          <div className="report-title">{display_data.plan_name}</div>
          <div className="report-row-section">
            <div className="report-row">
              <span className="report-left"><Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.ORDER_NO,{lng:tgtLangST})}</Trans></span>
              <span className="report-right">{display_data.order_no}</span>
            </div>
            <div className="report-row">
              <span className="report-left"><Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.TOTAL_PRICE,{lng:tgtLangST})}</Trans></span>
              <span className="report-right">{`${display_data.currency} ${display_data.total_price}`}</span>
            </div>
            {applyCoupon && couponCode && (
            <div className="report-row">
              <span className="report-left"><Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.APPLIED_COUPON,{lng:tgtLangST})}</Trans></span>
              <span className="report-right">{couponCode}</span>
            </div>
            )}
            <div className="report-row">
              <span className="report-left"><Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.DISCOUNT,{lng:tgtLangST})}</Trans></span>
              <span className="report-right">{`${display_data.currency} ${display_data.discount_price}`}</span>
            </div>
            <div className="report-row paid-row">
              <span className="report-left"><Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.MY_ORDERS_PAID,{lng:tgtLangST})}</Trans></span>
              <span className="report-right">{`${display_data.currency} ${display_data.paid_price}`}</span>
            </div>
          </div>
        </div>

        <div>
          <CommonButton className="common-button-green" label={<Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.DONE,{lng:tgtLangST})}</Trans>} onClick={btnActionHandler} />
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
